import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import {
  DokumentOSmanjenjuDto,
  EOtpremniceClient,
  GetDokumentOSmanjenjuQuery,
  IzmeneOsnovicaClient,
  StavkaRacunaDto,
} from '@kodit/core/data-api';
import { AlertService, BaseService } from '@kodit/core/services';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, finalize, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DokumentOSmanjenjuResolver
  extends BaseService
  implements Resolve<DokumentOSmanjenjuDto> {
  constructor(
    private _client: IzmeneOsnovicaClient,
    private _eOtpremniceClient: EOtpremniceClient,
    private _router: Router,
    private _alertService: AlertService
  ) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<DokumentOSmanjenjuDto>
    | Promise<DokumentOSmanjenjuDto>
    | DokumentOSmanjenjuDto
    | null {
    const id = Number.parseInt(route.paramMap.get('id'));

    const eOtpremnicaBaseIdsZaPreuzimanje: number[] =
      this._router.getCurrentNavigation()?.extras?.state?.[
        'eOtpremnicaBaseIdsZaPreuzimanje'
      ];

    return this._client
      .getDokumentOSmanjenju(new GetDokumentOSmanjenjuQuery({ id: id }))
      .pipe(
        map((x) => x.data),
        switchMap((dto) =>
          this._saPreuzetimStavkama(dto, eOtpremnicaBaseIdsZaPreuzimanje)
        ),
        catchError(this.handleError),
        finalize(() => {
          //this._configService.setIsBusy = false;
        })
      );
  }

  private _saPreuzetimStavkama(
    dto: DokumentOSmanjenjuDto,
    eOtpremnicaBaseIdsZaPreuzimanje: number[]
  ): Observable<DokumentOSmanjenjuDto> {
    if (!eOtpremnicaBaseIdsZaPreuzimanje?.length) {
      return of(dto);
    }

    return forkJoin(
      eOtpremnicaBaseIdsZaPreuzimanje.map((otpremnicaId) =>
        this._eOtpremniceClient.getStavkeRacunaZaEOtpremnicu(otpremnicaId)
      )
    ).pipe(
      map((rezultati) => {
        rezultati
          .filter((r) => !r.succeeded)
          .forEach((r) => this._alertService.addWarnMsgs(r.messages));

        const preuzeteStavke: StavkaRacunaDto[] = rezultati
          .filter((r) => r.succeeded)
          .reduce((sve, r) => sve.concat(r.data), [] as StavkaRacunaDto[]);

        dto.racunDto.stavkeDto = [
          ...(dto.racunDto.stavkeDto ?? []),
          ...preuzeteStavke,
        ].map((s, i) => new StavkaRacunaDto({ ...s, redniBroj: i + 1 }));

        return dto;
      })
    );
  }
}
